import { useImageAnnotatorContext } from "@msuite/image-annotator";

/** Props Interface */
interface AnnotationTextProps {
	cx: number;
	cy: number;
	text: string;
	transform?: string;
}

export function AnnotationText({ cx, cy, text, transform }: AnnotationTextProps) {
	/** Context */
	const context = useImageAnnotatorContext();

	const fontSize = 18 / context.baseScale;

	/** Render */
	return (
		<g transform={transform}>
			<text
				x={cx}
				y={cy}
				textAnchor="middle"
				fontSize={fontSize}
				stroke="black"
				strokeWidth={4 / context.baseScale}
				strokeLinejoin="round"
				dy={-fontSize * 0.45}
			>
				{text}
			</text>
			<text
				x={cx}
				y={cy}
				textAnchor="middle"
				fill="white"
				fontSize={fontSize}
				dy={-fontSize * 0.45}
			>
				{text}
			</text>
		</g>
	);
}
